// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"9776d091","239":"5491b2ce","386":"d5dfdb65","500":"32705fc2","732":"a38800b4","760":"b57ba87a","977":"00b284dc"}[chunkId] + ".chunk.js";
};